import { getPublicHttpClient, errorDesconocido, safeHandle401 } from "../../../core/utils/httpClient";
import { ConfigProvider } from "antd";

export function error(error) {
    return { type: "UNRESTRICTED_THEME_ERROR", error };
}

export function loading(loading) {
    return { type: "UNRESTRICTED_THEME_LOADING", loading };
}

export function success(data) {
    return { type: "UNRESTRICTED_THEME_SUCCESS", data };
}

export function reset() {
    return { type: "UNRESTRICTED_THEME_RESET" };
}

const getRootState = (state) => state.unrestricted.theme;

const isLoaded = (state) => getRootState(state).loaded;
const isLoading = (state) => getRootState(state).loading;
const getError = (state) => getRootState(state).error;
const getData = (state) => getRootState(state).data;

export { getData, isLoaded, isLoading, getError };

const updateTheme = (theme) => {
    ConfigProvider.config({
        theme: {
            ...theme,
        },
    });

    //const fontFamilyRule = `:root{--ant-font-family:'${theme.fontFamily}'}`;
    //document.documentElement.style.setProperty('--your-variable', '#CCC');
    //var sheet = document.styleSheets[0];
    //sheet.insertRule(fontFamilyRule);

    document.documentElement.style.setProperty("--ant-font-family", theme.fontFamily);
    document.documentElement.style.setProperty("--ant-dark-color", theme.darkColor);
    document.documentElement.style.setProperty("--ant-light-color", theme.lightColor);
};

export function testTheme(form) {
    return async (dispatch, getState) => {
        const current = getData(getState());

        const newTheme = {
            ...current,
            ...form,
            darkMenu: form.darkMenu ? "true" : "false",
            darkHeader: form.darkHeader ? "true" : "false",
        };

        dispatch(success(newTheme));
        updateTheme(newTheme);
    };
}

export function loadThemeFormPublic() {
    return async (dispatch, getState) => {
        dispatch(loading());

        const url = "/public/theme";
        const headers = { "Content-Type": "application/json" };

        try {
            const cliente = await getPublicHttpClient(dispatch, getState());
            const response = await cliente.get(url, {}, { headers: headers });

            //ConfigProvider.config({
            //    theme: {
            //        ...response.data,
            //    }
            //});
            //document.documentElement.style.setProperty('--your-variable', '#CCC');
            //var sheet = document.styleSheets[0];
            //sheet.insertRule(":root{--ant-font:'sans-serif'}");

            dispatch(success(response.data));

            updateTheme(response.data);

            return response.data;
        } catch (e) {
            //Ignoramos los errores
            return false;
        }
    };
}
